import { EmployeeType } from "../models";

export default (params, resourceName) => {

  if (resourceName === 'employees') {
    params.filter = { ...params.filter, type: params.filter.type || EmployeeType.chain };
  }

  if (resourceName === '_employees') {
    params.filter = { ...params.filter, type: EmployeeType.place };
  }

  // As duas listagens batem no mesmo endpoint e se separam pelo is_cash.
  if (resourceName === 'chains/chainId/products') {
    params.filter = { ...params.filter, isCash: false };
  }

  if (resourceName === 'money-products') {
    params.filter = { ...params.filter, isCash: true };
  }

  return params;
};